import { IRolePermissionInitialState } from "../../../types/permissions/permissionRoleInterface";
import { PermissionRoleActionTypes, PermissionRoleActions } from "../../actionTypes/permissions/permissionRoleActionTypes";


const initialState: IRolePermissionInitialState = {
  permissionRoleList: {
    sections: [],
    roles: [],
    departmentId: null
  },
};

export default function permissionRoleReducer(state = initialState, action: PermissionRoleActionTypes): IRolePermissionInitialState {
  switch (action.type) {
    case PermissionRoleActions.SET_PERMISSION_ROLE_LIST:
      return {
        ...state,
        permissionRoleList: {
          ...state.permissionRoleList,
          sections: action?.payload?.permissionRoleList?.sections,
          roles: action?.payload?.permissionRoleList?.roles,
          departmentId: action.payload.departmentId
        }
      };
      
    default:
      return state;
  }
}
